<template>
  <feishu-auth>
    <div class="right-card">
      <div class="right_header">
        <div class="title label"><a-icon type="team"></a-icon> 飞书工作群</div>
        <div class="action"><a-button type="primary" size="small" @click="bingGroup">绑定</a-button></div>
      </div>
      <a-divider class="divider"></a-divider>
      <div class="group-list">
        <a-list item-layout="horizontal" :data-source="list" class="list">
          <a-list-item slot="renderItem" slot-scope="item">
            <item :groupInfo="item" @unbindGroup="unBindGroup(item)" class="item"/>
          </a-list-item>
        </a-list>
      </div>
     
    </div>
    <a-modal v-model="modal.visible" title="绑定飞书群" @ok="handleModalOk">
      <group-select v-if="modal.visible" @change="groupChange"></group-select>
      <template v-if="selectGroupId">
        <div v-if="!selectGroupInfo.external" class="tips">
          <a-icon type="info-circle" theme="twoTone" /> 绑定飞书群后，天池机器人会自动进群， 帮助沉淀群内文档链接图片信息， 仅群内成员在天池可见
        </div>
        <div v-else class="tips tips-warn">
          <a-icon type="info-circle" style="color:orangered" theme="filled" /> 天池机器人无法自动进入外部群，无法自动同步群内资料，已同步资料不受影响
        </div>
      </template>
    </a-modal>
  </feishu-auth>
</template>
<script>
import { queryFeishuGroupList, bindFeishuGroup, unbindFeishuGroup } from '@/api/companyGroup';
import GroupSelect from './groupSelect';
import FeishuAuth from '@/components/feishuComponents/feishuAuth';
import Item from './groupItem';
export default {
  components: {
    GroupSelect,
    Item,
    FeishuAuth
  },
  props: {
    projectId: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      list: [],
      selectGroupId: '',
      selectGroupInfo: {},
      modal: {
        visible: false
      }
    };
  },
  mounted() {
    this.getGroupList();
  },
  methods: {
    getGroupList() {
      queryFeishuGroupList({ companyId: this.projectId }).then(res => {
        if (res.code === 200) {
          this.list = res.data;
        }
      });
    },
    bingGroup() {
      this.modal.visible = true;
      this.selectGroupId = '';
    },
    unBindGroup(item) {
      unbindFeishuGroup({
        companyId: this.projectId,
        feishuGroupId: item.groupId
      }).then(res => {
        this.getGroupList();
      });
    },
    handleModalOk() {
      if (!this.selectGroupId) {
        this.$message.error('请选择群组');
        return;
      }
      bindFeishuGroup({
        ...this.selectGroupInfo,
        companyId: this.projectId,
        feishuGroupId: this.selectGroupId
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('绑定成功');
          this.getGroupList();
          this.modal.visible = false;
        }
      });
    },
    groupChange(group) {
      this.selectGroupId = group.groupId;
      this.selectGroupInfo = group;
    }
  }
};
</script>
<style lang="less" scoped>
.tips {
  margin: 10px 0;
}
.tips-warn {
  color: orangered;
}

.group-list {
  padding: 0 16px;
  .list {
    // margin: 8px 16px;
    .item {
      margin: 12px 0;
    }
  }
}
.right-card {
  /deep/ .ant-empty-normal {
    margin: 8px 0;
    zoom: 0.9;
  }
}
</style>
